import * as React from 'react';
import Button, { Props as ButtonProps } from '../Button/Button';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';

export interface Props extends Omit<ButtonProps, 'level'> {}

/**
 * A Button under the hood, but set up with a
 * standard prop configuration for a Dropdown.
 */
const DropdownButton: React.FunctionComponent<Props> = (props: Props) => {
  const { children } = props;

  return (
    <Button { ...props }
        alignChildrenHorizontal="start"
        fullWidth
        gap="x4"
        level="secondary">
      <Flex
          alignChildrenVertical="middle"
          direction="horizontal"
          gap="x2"
          grow
          shrink>
        { children }
      </Flex>

      <Flex>
        <Icon name="ChevronDown" />
      </Flex>
    </Button>
  );
};

export default DropdownButton;
